import React from 'react';
import NavigateBefore from '@material-ui/icons/ErrorOutline';
import Typography from '@material-ui/core/Typography';

const defaultMessage = 'Sorry, something went wrong, please try again later.';

const styles = {
  main: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'center',
    padding: '20px'
  },
  text: {
    marginLeft: '10px'
  }
};

const ErrorMessage = ({ message }) => (
  <div style={styles.main}>
    <NavigateBefore />
    <Typography variant="subheading" style={styles.text}>
      {message || defaultMessage}
    </Typography>
  </div>
);

export default ErrorMessage;
